import React, { useEffect, useState } from "react";
import "./jsontask17.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faBookmark } from "@fortawesome/free-regular-svg-icons";
import {
  faChevronDown,
  faLocationDot,
  faMagnifyingGlass,
} from "@fortawesome/free-solid-svg-icons";
export function Profilemenu() {
  const [profile, setProfile] = useState([]);
  const [show, setShow] = useState(false);
  useEffect(() => {
    fetch("/profile.json")
      .then((data) => data.json())
      .then((da) => setProfile(da));
  });
  const handlyShoe = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="profilemenubody">
        <div className="profilemenubody1">
          <nav class="navbar navbar-expand-lg navbar-light bg-light profilemenunav">
            <a class="navbar-brand" href="#">
              LOGO
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarTogglerDemo02"
              aria-controls="navbarTogglerDemo02"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
              <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                <li className="nav-item active">
                  <button
                    className="btn bg-violet my-2 px-3 my-sm-0 text-center"
                    type="submit"
                  >
                    Find Canditates
                  </button>
                </li>
                <li className="nav-item active">
                  <a className="nav-link text-light" href="#">
                    Find Jobs
                  </a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link text-light" href="#">
                    Find Compaines
                  </a>
                </li>
              </ul>
              <form class="form-inline my-2 my-lg-0">
                <FontAwesomeIcon icon={faBell} className="profilemenubtn3" />
                <button
                  class="btn btn-outline-light my-2 my-sm-0"
                  type="submit"
                >
                  Login
                </button>
                <button
                  className="btn bg-violet my-2 px-3 my-sm-0 text-center"
                  type="submit"
                >
                  Register
                </button>
              </form>
            </div>
          </nav>
          <div className="container py-5 text-center">
            <h1 className="text-center profiletext pt-lg-5 pb-lg-3">
              Find the candidates as per your requirements
            </h1>
            <div className="cent pb-lg-5">
              <div className="row bg-light p-2 w-75 bord">
                <FontAwesomeIcon
                  icon={faMagnifyingGlass}
                  className="m-2 text-center"
                />
                <input
                  className="form-control mr-sm-3 col-lg-4 nonline"
                  type="search"
                  placeholder="Job Title / Keyword"
                />
                <h1 className="pr-5 displayspan">|</h1>
                <FontAwesomeIcon icon={faLocationDot} className="m-2" />
                <input
                  className="form-control mr-sm-2 col-lg-3 nonline"
                  type="search"
                  placeholder="Add Country / City"
                />
                <button
                  className="btn profilemenubtn2 my-2 px-5 my-sm-0 text-center"
                  type="submit"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row justify-content-around py-4">
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              Experience
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              HTML/CSS
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              Bangalore
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              UI/UX Designer
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              Gender
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
          <div class="dropdown">
            <button
              class="btn dropdowncolor dropdown-toggle px-lg-5"
              type="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              Age
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" href="#">
                Action
              </a>
              <a class="dropdown-item" href="#">
                Another action
              </a>
              <a class="dropdown-item" href="#">
                Something else here
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row p-lg-5 text-center">
          {profile.map((value, index) => (
            <>
              <div className="p-3 col-lg-3 profilecard">
                <div className="card profilecard2">
                  <img src={value.img} className="card-img-top" />
                  <span onClick={handlyShoe} className="profilecard1">
                    {show ? (
                      <FontAwesomeIcon icon={faBookmark} shake />
                    ) : (
                      <FontAwesomeIcon icon={faBookmark} />
                    )}
                  </span>
                  <div className="card-body">
                    <h5 className="card-title">{value.name}</h5>
                    <p className="card-text">{value.position}</p>
                    <a href="#" className="btn profilemenubtn2">
                      VIEW
                    </a>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
                
      </div>
      <div className="container-fluid">
        <div className="row">
          <h6 className="text-center col-lg-12">See All Result</h6>
          <span className="text-center col-lg-12">
            <FontAwesomeIcon icon={faChevronDown} />
          </span>
        </div>
      </div>
    </>
  );
}
